var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "activities-tab-navbar",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c("list-edition-toolbar", {
            attrs: {
              buttons: _vm.toolbarButtons,
              "horizontal-alignment": "right"
            },
            on: {
              add: function($event) {
                return _vm.$emit("addActivity")
              }
            }
          }),
          _vm._v(" "),
          _c("toggle-buttons", {
            staticStyle: { margin: "6px 8px" },
            attrs: { buttons: _vm.toggleButtons },
            model: {
              value: _vm.mode,
              callback: function($$v) {
                _vm.mode = $$v
              },
              expression: "mode"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("activities-table", {
        attrs: {
          "object-uuid": _vm.objectUuid,
          "object-layer": _vm.objectLayer,
          mode: _vm.mode
        },
        on: {
          openActivity: function($event) {
            return _vm.$emit("openActivity", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74d11566", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74d11566","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/ActivitiesList.vue
// module id = null
// module chunks = 